
import atlas from "@/components/atlas.vue";
import { trackLoginImpression } from "@/plugins/hwtag/events";

const IMG_URL = "https://resource.xp-pen.com/img/Contest/MP13Contest/";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.hwug.xfans_community_flutter";
const APP_STORE_URL = "https://apps.apple.com/app/xppen-space/id6800538044";
// 作品集活动 id。未配置时不请求，避免展示其它比赛的作品
const MP13_ACTIVITY_ID = 67;

export default {
  components: { atlas },
  data() {
    return {
      imgUrl: IMG_URL,
      googlePlayUrl: GOOGLE_PLAY_URL,
      appStoreUrl: APP_STORE_URL,
      sidebar: "en",
      navActive: "contestInfo",
      scrollTop: 0,
      bannerH: 0,
      headerH: 0,
      navTopHeight: 0,
      currentPage: 1,
      source: null,
      pendingUploadAfterLogin: false,
      isMobileLayout: false, // 视口不超过 1080 时改用 app 目录图片
    };
  },
  head() {
    return {
      title: this.$t("mp13Contest.SEO_TITLE"),
      meta: [
        { name: "keywords", content: "XPPen, ibisPaint, Magic Pro 13, Drawing Contest" },
        { hid: "description", name: "description", content: this.$t("mp13Contest.SEO_DESC") },
      ],
      link: [
        { rel: "preconnect", href: "https://fonts.googleapis.com" },
        { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "anonymous" },
        { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap" },
      ],
    };
  },
  computed: {
    /** 仅这场比赛投放英语和日语 */
    langOptions() {
      return [
        { type: "en", label: this.$t("mp13Contest.LANG_EN") },
        { type: "jp", label: this.$t("mp13Contest.LANG_JP") },
      ];
    },
    navItems() {
      return [
        { id: "contestInfo", label: this.$t("mp13Contest.NAV_INTRO") },
        { id: "awards", label: this.$t("mp13Contest.NAV_AWARDS") },
        { id: "submit", label: this.$t("mp13Contest.NAV_SUBMIT") },
        { id: "terms", label: this.$t("mp13Contest.NAV_TERMS") },
        { id: "gallery", label: this.$t("mp13Contest.NAV_GALLERY") },
      ];
    },
    bannerPc() {
      return this.sidebar === "jp" ? "banner_jp.webp" : "banner_en.webp";
    },
    bannerMobile() {
      return this.sidebar === "jp" ? "app/banner_jp.webp" : "app/banner_en.webp";
    },
    /** 滚过 banner 后才显示右侧语言栏 */
    showLangSidebar() {
      return this.scrollTop > this.bannerH;
    },
    introKeys() {
      return ["mp13Contest.INTRO_1", "mp13Contest.INTRO_2", "mp13Contest.INTRO_3"];
    },
    timeline() {
      return [1, 2, 3].map((n) => ({
        label: this.$t("mp13Contest.TIME_LABEL_" + n),
        date: this.$t("mp13Contest.TIME_DATE_" + n),
      }));
    },
    /** 日语打开日文介绍页，其余打开英文介绍页 */
    ibisUrl() {
      return this.sidebar === "jp"
        ? "https://ibispaint.com/about.jsp?lang=ja"
        : "https://ibispaint.com/about.jsp?lang=en";
    },
    cueGroups() {
      const isJp = this.sidebar === "jp";
      const pc = isJp
        ? ["contest_img_15.webp", "contest_img_16.webp", "contest_img_17.webp"]
        : ["contest_img_24.webp", "contest_img_25.webp", "contest_img_26.webp"];
      const mobile = isJp
        ? ["app/JP-01.webp", "app/JP-02.webp", "app/JP-03.webp"]
        : ["app/UK-01.webp", "app/UK-02.webp", "app/UK-03.webp"];
      return [0, 1, 2].map((index) => ({
        title: this.$t("mp13Contest.CUE_TITLE_" + (index + 1)),
        pc: pc[index],
        mobile: mobile[index],
      }));
    },
    awards() {
      // 日语走日本站，其余走国际站
      const host = this.sidebar === "jp" ? "https://www.xp-pen.jp" : "https://www.xp-pen.com";
      return [
        this.buildAward(1, "contest_img_22.webp", host + "/product/magic-pro-13.html", true),
        this.buildAward(2, "contest_img_10.webp", host + "/product/artist-16-3rd.html", true),
        this.buildAward(3, "contest_img_9.webp", host + "/product/artist-12-3rd.html", true),
        this.buildAward(4, "contest_img_11.webp", host + "/product/deco-640.html", false),
      ];
    },
    criteria() {
      return [1, 2, 3].map((n) => ({
        title: this.$t("mp13Contest.CRITERIA_" + n + "_TITLE"),
        percent: this.$t("mp13Contest.CRITERIA_" + n + "_PERCENT"),
        desc: this.$t("mp13Contest.CRITERIA_" + n + "_DESC"),
      }));
    },
    judges() {
      return [
        { image: "contest_img_30.webp", name: this.$t("mp13Contest.JUDGE_1_NAME"), desc: this.$t("mp13Contest.JUDGE_1_DESC") },
        { image: "contest_img_12.webp", name: this.$t("mp13Contest.JUDGE_2_NAME"), desc: this.$t("mp13Contest.JUDGE_2_DESC"), link: "https://www.instagram.com/georgeparkart/" },
        { image: "contest_img_14.webp", name: this.$t("mp13Contest.JUDGE_3_NAME"), desc: this.$t("mp13Contest.JUDGE_3_DESC") },
      ];
    },
    requirements() {
      return [1, 2, 3].map((n) => ({
        title: this.$t("mp13Contest.REQUIREMENT_" + n + "_TITLE"),
        desc: this.$t("mp13Contest.REQUIREMENT_" + n + "_DESC"),
      }));
    },
    galleryList() {
      const list = this.source && this.source.result;
      return Array.isArray(list) ? list : [];
    },
  },
  watch: {
    "$i18n.locale"(locale) {
      const lang = this.resolveContestLang(locale);
      if (this.sidebar !== lang) this.sidebar = lang;
      if (process.client) document.title = this.$t("mp13Contest.SEO_TITLE");
    },
    "$store.state.isLogin"(loggedIn) {
      if (loggedIn && this.pendingUploadAfterLogin) {
        this.pendingUploadAfterLogin = false;
        this.goToReleaseWork();
      }
    },
  },
  created() {
    const lang = this.resolveContestLang(this.$route.query.lang || this.$i18n.locale || this.$store.state.locale);
    this.sidebar = lang;
    if (this.$i18n.locale !== lang) this.$loadLanguageAsync(lang);
  },
  mounted() {
    this.calculateBannerHeight();
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.calculateBannerHeight);
    window.addEventListener("load", this.calculateBannerHeight);
    this.parametricWork();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
    window.removeEventListener("resize", this.calculateBannerHeight);
    window.removeEventListener("load", this.calculateBannerHeight);
  },
  methods: {
    /** 手机端背景改用 app 目录里的对应图 */
    panelImage(fileName) {
      return (this.isMobileLayout ? "app/" : "") + fileName;
    },
    /** 奖项卡片。优秀奖没有现金项 */
    buildAward(index, image, url, hasCash) {
      const prizes = [
        { icon: "contest_img_20.webp", text: this.$t("mp13Contest.AWARD_" + index + "_IBIS") },
      ];
      if (hasCash) prizes.push({ icon: "contest_img_1.webp", text: this.$t("mp13Contest.AWARD_" + index + "_CASH") });
      prizes.push({ icon: "contest_img_29.webp", text: this.$t("mp13Contest.AWARD_" + index + "_COIN") });
      return {
        title: this.$t("mp13Contest.AWARD_" + index + "_TITLE"),
        product: this.$t("mp13Contest.AWARD_" + index + "_PRODUCT"),
        image,
        url,
        prizes,
      };
    },
    resolveContestLang(lang) {
      const locale = String(lang || "").trim();
      return this.langOptions.some((item) => item.type === locale) ? locale : "en";
    },
    /** 只在英语和日语之间切换，并同步全站语种 */
    changeLanguage(lang) {
      const locale = this.resolveContestLang(lang);
      this.sidebar = locale;
      this.$loadLanguageAsync(locale);
    },
    calculateBannerHeight() {
      this.isMobileLayout = window.innerWidth <= 1080;
      if (this.$refs.bannerHeight) this.bannerH = this.$refs.bannerHeight.offsetHeight;
      const header = document.querySelector('header');
      if (!header) return;
      this.navTopHeight = header.offsetHeight;
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.updateNavActive();
    },
    /** 按当前滚动位置高亮导航 */
    updateNavActive() {
      const nav = document.getElementById("navContent");
      const offset = (nav ? nav.offsetHeight : 0) + this.navTopHeight + 8;
      const mark = this.scrollTop + offset;
      let active = "contestInfo";
      this.navItems.forEach((item) => {
        const el = document.getElementById(item.id);
        if (!el) return;
        const top = el.getBoundingClientRect().top + window.pageYOffset;
        if (top <= mark) active = item.id;
      });
      this.navActive = active;
    },
    handleScrollTo(id) {
      const el = document.getElementById(id);
      const nav = document.getElementById("navContent");
      if (!el || !nav) return;
      const top = el.getBoundingClientRect().top + window.pageYOffset - nav.offsetHeight - this.headerH;
      window.scrollTo({ top, behavior: "smooth" });
      this.navActive = id;
    },
    /** 参赛作品。活动 id 未配置时保持设计图里的空位 */
    async parametricWork(page = 1) {
      if (!MP13_ACTIVITY_ID) return;
      const res = await this.$global.parametricWork({ activityId: MP13_ACTIVITY_ID, page, award: 0 });
      this.source = res;
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.parametricWork(page);
    },
    handleTrack(clickType, clickName, linkUrl) {
      this.$track("promotion_page_click", {
        promotion_type: "Connect Magic into One World Drawing Contest",
        item_skuid: "null",
        item_sku_name: "null",
        item_sku_key_name: "null",
        link_domain: linkUrl,
        link_url: linkUrl,
        click_type: clickType,
        click_name: clickName,
      });
    },
    isFlutterApp() {
      return typeof window !== "undefined" && window.FlutterChannel && typeof window.FlutterChannel.postMessage === "function";
    },
    goToReleaseWork() {
      this.$router.push({ path: "/releaseWork", query: { type: 1 } });
    },
    /** 未登录先打开登录，登录成功后再进入投稿页 */
    handleUpload() {
      const link = "https://community.xp-pen.com/releaseWork?type=1";
      if (this.isFlutterApp()) {
        // this.handleTrack("点击提交作品", "Submit your entry", link);
        window.FlutterChannel.postMessage(JSON.stringify({ action: "public_work" }));
        return;
      }
      if (!this.$store.state.isLogin) {
        this.pendingUploadAfterLogin = true;
        trackLoginImpression("点击", "参与比赛", "Submit your entry");
        const useNewLogin = this.$store.state.siteConfig && this.$store.state.siteConfig.DialogPassportSwitch == "1";
        if (useNewLogin) {
          this.$store.commit("OPEN_AUTH_MODAL", {
            tab: "login",
            redirectToUserCenter: false,
            source: { elementTypeName: "参与比赛", clickName: "Submit your entry" },
          });
        } else {
          this.$jumpTerminus(1);
        }
        return;
      }
      // this.handleTrack("点击提交作品", "Submit your entry", link);
      this.goToReleaseWork();
    },
  },
};
